function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.904,
    height: 19.7,
    viewBox: "0 0 17.904 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7325"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Subtraction 2",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.054 9.185H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h13.9a2 2 0 0 1 2 2v5.184a2 2 0 0 1-2 2h-2.05V7.143h-9.8v2.04z",
    style: {
      stroke: "none"
    },
    transform: "translate(0 8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.054 8.184v-2.04H14.85v2.04h1.054a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v5.184c0 .551.449 1 1 1h1.054m1 1H2c-1.103 0-2-.898-2-2V2C0 .897.897 0 2 0h13.904c1.103 0 2 .897 2 2v5.184c0 1.102-.897 2-2 2H13.85v-2.04H4.054v2.04z",
    style: {
      fill: "#14a4c2",
      stroke: "none"
    },
    transform: "translate(0 8.25)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 182",
    transform: "translate(3.35 9.857)",
    style: {
      strokeWidth: ".5px",
      stroke: "#ffa539",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.306,
    cy: 0.306,
    style: {
      stroke: "none"
    },
    r: 0.306
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.306,
    cy: 0.306,
    style: {
      fill: "none"
    },
    r: 0.056
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 183",
    transform: "translate(3.35 10.809)",
    style: {
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.306,
    cy: 0.306,
    style: {
      stroke: "none"
    },
    r: 0.306
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.306,
    cy: 0.306,
    style: {
      fill: "none"
    },
    r: 0.056
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 914",
    d: "M5126.887-2.8h17.1",
    transform: "translate(-5126.082 15.644)",
    style: {
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 915",
    d: "M5126.887-2.8h1.149",
    transform: "translate(-5122.469 12.965)",
    style: {
      strokeLinecap: "round",
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 916",
    d: "M5126.887-2.8h1.149",
    transform: "translate(-5122.469 13.917)",
    style: {
      strokeLinecap: "round",
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7322"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 606",
    style: {
      stroke: "#14a4c2",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.809 0v5.4H0V1.809A1.809 1.809 0 0 1 1.809 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(2.89 3.554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.309.5v4.4H.5V1.309A.809.809 0 0 1 1.309.5z",
    style: {
      fill: "none"
    },
    transform: "translate(2.89 3.554)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 607",
    style: {
      stroke: "#14a4c2",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.809 1.809 0 0 1 1.809 1.809V5.4H0V0z",
    style: {
      stroke: "none"
    },
    transform: "translate(13.138 3.554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5a.809.809 0 0 1 .809.809V4.9H.5V.5z",
    style: {
      fill: "none"
    },
    transform: "translate(13.138 3.554)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 917",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.9v4.432H0z",
    style: {
      stroke: "none"
    },
    transform: "translate(3.962 15.268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v2.432h7.904V1H1M0 0h9.904v4.432H0V0z",
    style: {
      fill: "#ffa539",
      stroke: "none"
    },
    transform: "translate(3.962 15.268)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 918",
    d: "M5126.887-2.8h6.206",
    transform: "translate(-5121.006 19.832)",
    style: {
      strokeLinecap: "round",
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 921",
    d: "M5126.887-2.8h9.9",
    transform: "translate(-5122.887 3.051)",
    style: {
      strokeLinecap: "round",
      strokeWidth: ".5px",
      stroke: "#ffa539",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 919",
    d: "M5126.887-2.8h6.206",
    transform: "translate(-5121.006 20.739)",
    style: {
      strokeLinecap: "round",
      stroke: "#14a4c2",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 922",
    d: "M5126.887-2.8h9.9",
    transform: "translate(-5122.928 3.941)",
    style: {
      strokeLinecap: "round",
      strokeWidth: ".5px",
      stroke: "#ffa539",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 920",
    d: "M6192.669 300.169v-5.384h9.288v5.384",
    transform: "translate(-6188.403 -291.919)",
    style: {
      stroke: "#ffa539",
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.2d669c79dedf12bda27401ecf559d0bc.svg";
export { ForwardRef as ReactComponent };